import axiosInstance from "../../utils/config/config";

export const getAllPhotos = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllPhotosRequest",
    });
    const { data } = await axiosInstance.get(`/gallery/getAllPhotos`);
    dispatch({
      type: "getAllPhotosSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "getAllPhotosFailure",
      payload: true,
    });
  }
};
